import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import { StandaloneModule } from './standalone.module';
import { AppointmentsComponent } from '../components/ehr/appointments/appointments.component';

@NgModule({
  declarations: [AppointmentsComponent],
  imports: [SharedModule, StandaloneModule],
  exports: [AppointmentsComponent],
})
export class AppointmentsModule {}
